// Helpers
import { getTicketingErrorMessage } from 'pages/Events/helpers';
// UI
import { errorNotification, successNotification } from 'ui/Notification';

/** Runs a ticketing mutation and tells the admin how it went; resolves to whether it worked. */
export const runTicketingChange = async <Result>(
  change: () => Promise<Result>,
  success: string | ((result: Result) => string),
  failure: string
): Promise<boolean> => {
  try {
    const result = await change();

    successNotification(
      typeof success === 'function' ? success(result) : success
    );
    return true;
  } catch (error) {
    errorNotification(getTicketingErrorMessage(error, failure));
    return false;
  }
};
